// HOAD: frase real de cliente acima do botão de compra. Nada é inventado: só
// aparece avaliação publicada do Judge.me (nota 4+), inteira e curta o
// bastante pra caber em 1-2 linhas, sem cortar o que o cliente escreveu.
// Prioridade: fala de ajuste/tamanho (objeção nº 1), depois conforto. SÓ do
// próprio produto (nunca de outro), sem fallback pra loja.
(function () {
  var HOAD_API_BASE = 'https://app.hoad.com.br';
  var MIN = 25;
  var MAX = 120;
  var AJUSTE = /tamanho|modelagem|ajuste|veste|serviu|n[aã]o (sai|desce)|medida/i;
  var CONFORTO = /confort|compress|leve|macio/i;
  // Só entra frase que elogia: nota 4+ ainda pode trazer ressalva ("o tamanho
  // poderia ser maior"), e isso reforçaria a objeção em vez de quebrar.
  var POSITIVO = /perfeit|[oó]tim|excelente|amei|amo\b|maravilh|confort|lind|recomend|top\b|n[aã]o (sai|desce)|adorei|sensacional|incr[ií]vel/i;
  var RESSALVA = /poderia|pouquinho|pequen|maior|menor|apert|folga|infelizmente|por[eé]m|\bmas\b|s[oó] que|detalhe|demor|problema|ruim|n[aã]o (gost|serv|recom|vale)|decepc|defeito|rasg|desbot|encolh|deveria|faltou/i;

  function limpa(t) {
    return String(t || '')
      // Emoji vira ponto final (senão cola as palavras: "apaixona😍Estou").
      .replace(/[\u{1F000}-\u{1FFFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}]+/gu, '. ')
      .replace(/([.!?])\s*\.(\s|$)/g, '$1$2')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function nomeCurto(r) {
    var n = (r.reviewer && r.reviewer.name) || r.name || '';
    var partes = String(n).trim().split(/\s+/).filter(Boolean);
    return partes.slice(0, 2).join(' ');
  }

  function escolher(reviews) {
    var melhor = null;
    (reviews || []).forEach(function (r) {
      if (r.published === false || Number(r.rating) < 4) return;
      var texto = limpa(r.body || r.content);
      if (texto.length < MIN || texto.length > MAX) return;
      if (RESSALVA.test(texto) || !POSITIVO.test(texto)) return;
      var pontos = AJUSTE.test(texto) ? 2 : CONFORTO.test(texto) ? 1 : 0;
      if (!melhor || pontos > melhor.pontos || (pontos === melhor.pontos && texto.length < melhor.texto.length)) {
        melhor = { pontos: pontos, texto: texto, autor: nomeCurto(r) };
      }
    });
    return melhor;
  }

  function buscar(query) {
    return fetch(HOAD_API_BASE + '/api/geral/judgeme-reviews?' + query)
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        return data.reviews || data.data || (Array.isArray(data) ? data : []);
      });
  }

  function mostrar(el, q) {
    el.querySelector('[data-hoad-objecao-text]').textContent = '“' + q.texto + '”';
    el.querySelector('[data-hoad-objecao-author]').textContent = q.autor ? '— ' + q.autor : '';
    el.querySelector('[data-hoad-objecao-quote]').hidden = false;
  }

  function init(el) {
    var pid = el.dataset.productId;
    var chave = 'hoad_objecao_v3_' + pid;
    try {
      var salvo = sessionStorage.getItem(chave);
      if (salvo) { mostrar(el, JSON.parse(salvo)); return; }
    } catch (e) { /* storage indisponível: segue sem cache */ }

    // 23/09 (André): a frase é SEMPRE do produto em questão, sem cair pra
    // avaliação de outro produto. Sem avaliação boa dele, o bloco fica só com
    // a garantia. Entre as elogiosas e sem ressalva, ajuste/tamanho vence
    // conforto, que vence elogio genérico.
    // Família = as cores do mesmo produto (uma cor é um produto no catálogo).
    window.HoadReviewsFamilia.buscar(el.dataset.productIds || pid, 30)
      .then(escolher)
      .then(function (q) {
        if (!q) return;
        mostrar(el, q);
        try { sessionStorage.setItem(chave, JSON.stringify(q)); } catch (e) { /* ignora */ }
      })
      .catch(function () { /* complemento: sem frase, some sem erro visível */ });
  }

  function boot() {
    document.querySelectorAll('[data-hoad-objecao]').forEach(function (el) {
      if (!el.__hoadObjecao) { el.__hoadObjecao = true; init(el); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
